import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { LoaderContext } from "../../../../../Services/Loader_Provider_Service/LoadingContext";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { SaveAnswer } from "../../Services/SelfLearning";


const QuestionOption = (args) => {
    const question = args.question;
    const showSubmitBtn = args.showBtn;
    const { CourseId } = useParams();
    const { ModuleId } = useParams();
    const { showLoading, hideLoading } = useContext(LoaderContext);
    const [answerlst, setAnswerLst] = useState([]);
    const [optionLst, setoptionLst] = useState([]);


    async function saveAnswer() {
        showLoading();
        let params = [
            {
                "Id": 0,
                "Userid": 0,
                "Quizid": 0,
                "Moduleid": 0,
                "Quesid": 0,
                "Answerid": 0,
                "Lessonid": 0,
                "Courseid": 0
            }
        ]
        try {
            // let reaponce = await SaveAnswer(params)
            hideLoading();
        } catch (error) {
            hideLoading();
        }
    }

    useEffect(() => {
        let answerList = [
            {
                "Quizid": answerlst?.QuizId,
                "Moduleid": answerlst?.Moduleid,
                "Quesid": answerlst?.QuestionId,
                "Answerid": answerlst?.Id,
                "Lessonid": answerlst?.LessonId,
                "Courseid": answerlst?.CourseId
            }
        ]
        setoptionLst((arr)=>[...arr,answerList])
       
    }, [answerlst])
    return (
        <div>
            <div className="detail">
                <span>Choose one option</span>
                <div key={question?.Id}>
                    <h3>{question?.QuestionText}</h3>
                    {question?.lstQuestionOptions?.map((option, optnIndex) => (
                        <div className="question">
                            <strong>  {option?.Options}</strong>
                            <input type="radio" name="fav_language" onClick={() => setAnswerLst(option)} />
                        </div>
                    ))}
                </div>
                {showSubmitBtn == true ?
                    <button onClick={saveAnswer} className="btn btn-danger mt-3 float-right" data-bs-toggle="modal" data-bs-target="#view-score" data-dismiss="modal">Submit</button>
                    : ''}
            </div>
            <div className="modal fade" id="view-score">
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content text-center">
                        <div className="modal-header d-block text-center">
                            <h5 className="modal-title m-auto">Result Score</h5>
                            <p className="mb-0">Last updated today 09.25</p>
                        </div>
                        <div className="progress blue">
                            <span className="progress-left">
                                <span className="progress-bar"></span>
                            </span>
                            <span className="progress-right">
                                <span className="progress-bar"></span>
                            </span>
                            <div className="progress-value">90%

                            </div>
                        </div>
                        <span>Out of 100</span>
                        <strong>Very good!</strong>
                        <p>Your score is in warm up model</p>
                        <div className="modal-footer m-auto">
                            <Link to={`/SelfLearningDashboard/CourseDetails/QuizDetails/QuizResult/${CourseId}`}><i className="fa fa-angle-right" aria-hidden="true" data-bs-toggle="modal"
                                data-bs-target="#viewquizzes" data-dismiss="modal"></i></Link>
                        </div>
                        <p>View Questions</p>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default QuestionOption;